(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('OnuUnauthorizedController', OnuUnauthorizedController);

    OnuUnauthorizedController.$inject = ['$scope', '$stateParams', '$rootScope', '$sce', '$translate', 'OnuService', 'RequestService', 'Authenticate', 'OnuData'];

    function OnuUnauthorizedController($scope, $stateParams, $rootScope, $sce, $translate, OnuService, RequestService, Authenticate, OnuData) {

        if (!Authenticate.hasPermission('onuList')) {
            return;
        }

        var vm = this;
        var hasError = false;
        vm.requestRunning = false;
        vm.dataSearch = {};

        vm.onuList = [];
        vm.list = {};
        vm.view = {};
        vm.orderSelected = '';
        vm.view.labelOrderSelected = '';
        vm.view.tooltip = '';
        vm.searchIsActive = false;

        vm.list.typeOrder = [
            {translateKey: 'alphabeticalOrderAToZ', name: 'Ordem alfabética (a-z)', paramObjectOrder: 'serialNumber'},
            {translateKey: 'alphabeticalOrderZToA', name: 'Ordem alfabética (z-a)', paramObjectOrder: '-serialNumber'},
            {translateKey: 'inclusionFirstOrder', name: 'Ordem de inclusão (asc)', paramObjectOrder: 'id'},
            {translateKey: 'inclusionLastOrder', name: 'Ordem de inclusão (desc)', paramObjectOrder: '-id'}
        ];

        // Actions
        vm.getUnauthorizedOnuList = getUnauthorizedOnuList;
        vm.removeAuthorizedOnu = removeAuthorizedOnu;
        vm.reload = reload;
        vm.setTypeOrder = setTypeOrder;
        vm.hasSearch = hasSearch;
        vm.hasNoSearch = hasNoSearch;
        vm.hasErrorList = hasErrorList;
        vm.toggle = toggle;
        vm.authorize = authorize;

        // Action Functions
        function setLabelOrderText(type) {
            switch (type) {
                case 'serialNumber':
                    vm.view.labelOrderSelected = vm.list.typeOrder[0]['translateKey'];
                    break;
                case '-serialNumber':
                    vm.view.labelOrderSelected = vm.list.typeOrder[1]['translateKey'];
                    break;
                case 'id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[2]['translateKey'];
                    break;
                case '-id':
                    vm.view.labelOrderSelected = vm.list.typeOrder[3]['translateKey'];
                    break;
            }
        }

        function getUnauthorizedOnuList(data) {

            vm.onuList.length = 0;
            RequestService.cancelRequests(['onus/unauthorized']);
            setRequestEnd();

            if (data && data.name) {
                OnuData.isSearch = true;
            } else {
                setRequestStart();
                OnuService.getUnauthorizedOnuList(data, true).then(successListOnu).catch(errorListOnu);
            }

        }

        function removeAuthorizedOnu(id) {
            vm.onuList.forEach(function (item, index, array) {
                if (item.serialNumber == id) {
                    array.splice(index, 1);
                }
            })
        }

        function listenerNewItemAuthorize() {
            $scope.$on('onuNewItemAuthorized', function (event, result) {
                removeAuthorizedOnu(result.serialNumber);
            });
        }

        function reload() {
            getUnauthorizedOnuList(vm.dataSearch);
        }

        function setTypeOrder(type) {
            toggle(null);
            vm.orderSelected = type;
            setLabelOrderText(type);
        }

        function hasSearch() {
            return !vm.requestRunning && OnuData.isSearch && !vm.onuList.length && !hasError;
        }

        function hasNoSearch() {
            return !vm.requestRunning && !OnuData.isSearch && !vm.onuList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.onuList.length && hasError;
        }

        function toggle(id) {
            vm.onuList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.updateOnuList').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function authorize(onuItem) {
            OnuService.authorizeOnuModalConstructor(onuItem);
        }

        // Request Callbacks
        function successListOnu(data) {
            var id = 1;
            vm.onuList = data.map(function (item) {
                item.id = id;
                id++;
                return item;
            });
            hasError = false;
            setRequestEnd();
        }

        function errorListOnu(response) {
            if (response.status != -1) {
                hasError = true;
                setRequestEnd();
            }
        }

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        function initialize() {
            if (!$stateParams.name) {
                getUnauthorizedOnuList();
            }
            vm.orderSelected = 'id';
            setLabelOrderText('id');
            getTooltip();
            listenerNewItemAuthorize();
        }

        initialize();

        $scope.$on('onuSearch', function (event, data) {
            OnuData.isSearch = false;
            vm.dataSearch = data;
            getUnauthorizedOnuList(data);
        });

        $scope.$on('onuItemDeleted', reload);
    }

})();
